import { getLeTableData } from './utils/leUtils';

const getVal = require('lodash/get');

export const stringconstants = {
  memberInfo: 'memberInfo',
  filledFormData: 'filledFormData',
  leEntityData: 'leEntityData',
  default: 'default',
  params: 'params',
};

/**
 *
 * @param {*} dataObj
 * @param {*} type
 */
/* eslint-disable no-restricted-syntax -- need */
export const getCompletePhoneNumber = (phoneNumbers, type) => {
  let combinedPhoneNumber = '';
  for (const number of phoneNumbers) {
    // default type will return the first non-empty phone number
    if (type === number.type || type === 'DEFAULT') {
      combinedPhoneNumber = number.countryCode ? number.countryCode : '';
      combinedPhoneNumber += number.phoneNumber ? number.phoneNumber : '';
      break;
    }
  }
  return combinedPhoneNumber.trim();
};

/* eslint-disable no-extra-parens -- need */
export const getCompleteAddress = (addresses, type) => {
  let combinedAddress = '';
  for (const address of addresses) {
    if (address.type === type) {
      combinedAddress = address.streetAddressLine1 ? address.streetAddressLine1 : '';
      combinedAddress += address.streetAddressLine2 ? (combinedAddress !== '' ? `, ${address.streetAddressLine2}` : address.streetAddressLine2) : '';
      combinedAddress += address.streetAddressLine3 ? (combinedAddress !== '' ? `, ${address.streetAddressLine3}` : address.streetAddressLine3) : '';
      combinedAddress += address.city ? (combinedAddress !== '' ? `, ${address.city}` : address.city) : '';
      combinedAddress += address.state ? (combinedAddress !== '' ? `, ${address.state}` : address.state) : '';
      combinedAddress += address.postalCode ? (combinedAddress !== '' ? `, ${address.postalCode}` : address.postalCode) : '';
      combinedAddress += address.country ? (combinedAddress !== '' ? `, ${address.country}` : address.country) : '';
      break;
    }
  }
  return combinedAddress.trim();
};
/* eslint-enable no-extra-parens -- need */
/* eslint-enable no-restricted-syntax -- need */

export const getDob = (dobObj, format) => {
  if (format === 'DD/MM/YYYY') {
    const day = Number(dobObj.day) < 10 ? `0${dobObj.day}` : dobObj.day;
    const month = Number(dobObj.month) < 10 ? `0${dobObj.month}` : dobObj.month;
    return `${day}/${month}/${dobObj.year}`;
  }
  return '';
};
/**
 * This method is a common method responsible to provide content from various
 * sources in required order
 * @param {*} isPreFilled
 * @param {*} preFilledWith
 * @param {*} fieldValue
 * @param {*} selectKey
 * @param {*} fetchUrl
 * @param {*} filledFormData
 * @param {*} memberInfo
 */

/* eslint complexity: ["error", 50] -- need to increase complexity */
export const getRequiredData = ({
  isPreFilled, preFilledWith, fieldValue, selectKey,
  fetchUrl, filledFormData, memberInfo, entityIndex,
}) => {
  let tempData;
  if (isPreFilled && preFilledWith === stringconstants.filledFormData && !fetchUrl) {
    if (filledFormData) {
      tempData = getVal(filledFormData, selectKey);
    }
  } else if (isPreFilled && preFilledWith === stringconstants.memberInfo && !fetchUrl) {
    if (memberInfo) {
      let preFilledVal = '';
      switch (selectKey) {
        case 'mobileNumberWithCountryCode':
          if (memberInfo.contacts && memberInfo.contacts.phone) {
            preFilledVal = getCompletePhoneNumber(memberInfo.contacts.phone, 'MOBILE');
          }
          break;
        case 'homeNumberWithCountryCode':
          if (memberInfo.contacts && memberInfo.contacts.phone) {
            preFilledVal = getCompletePhoneNumber(memberInfo.contacts.phone, 'HOME');
          }
          break;
        case 'workNumberWithCountryCode':
          if (memberInfo.contacts && memberInfo.contacts.phone) {
            preFilledVal = getCompletePhoneNumber(memberInfo.contacts.phone, 'WORK');
          }
          break;
        case 'defaultNumberWithCountryCode':
          if (memberInfo.contacts && memberInfo.contacts.phone) {
            preFilledVal = getCompletePhoneNumber(memberInfo.contacts.phone, 'DEFAULT');
          }
          break;
        case 'completePrimaryAddress':
          if (memberInfo.contacts && memberInfo.contacts.address) {
            preFilledVal = getCompleteAddress(memberInfo.contacts.address, 'PRIMARY');
          }
          break;
        case 'completeEmployerAddress':
          if (memberInfo.contacts && memberInfo.contacts.address) {
            preFilledVal = getCompleteAddress(memberInfo.contacts.address, 'EMPLOYER');
          }
          break;
        case 'dob':
          if (memberInfo.profile && memberInfo.profile.birthDate) {
            // default format hardcoded
            const format = 'DD/MM/YYYY';
            preFilledVal = getDob(memberInfo.profile.birthDate, format);
          }
          break;
        default: preFilledVal = getVal(memberInfo, selectKey);
      }
      tempData = preFilledVal;
    }
  } else if (isPreFilled && preFilledWith === stringconstants.leEntityData && !fetchUrl) {
    if (filledFormData && filledFormData.entityData) {
      const { entityData } = filledFormData;
      tempData = getLeTableData(entityData, entityIndex, selectKey);
    }
  } else if (fieldValue !== stringconstants.default && fieldValue !== '') {
    tempData = fieldValue;
  }
  return tempData;
};
